import { action, makeObservable, observable, reaction } from 'mobx';
import { isMobile } from '../../../core/helpers/isMobile';
import { userInfoStore } from '../../../store/userInfoStore';
import { freeBetStore } from '../../../store/freeBetStore';

class CoinFlipBetsStore {
  isBetsClosed = false;

  isDoSpinStart = false;

  isAllowCashOut = false;

  cashOutWin = null;

  odd = null;

  winAmount = null;

  winOdd = null;

  isDoSpinResult = false;

  lastResults = [];

  isStartAnimation = false;

  lastStepResult = null;

  isAllowSendBet = true;

  nextOdd = null;

  constructor() {
    makeObservable(this, {
      nextOdd: observable,
      winOdd: observable,
      winAmount: observable,
      cashOutWin: observable,
      odd: observable,
      lastResults: observable,
      isBetsClosed: observable,
      isDoSpinStart: observable,
      isDoSpinResult: observable,
      lastStepResult: observable,
      isAllowCashOut: observable,
      isAllowSendBet: observable,
      isStartAnimation: observable,
      setNextOdd: action.bound,
      setOdd: action.bound,
      setWinOdd: action.bound,
      setWinAmount: action.bound,
      setLastResults: action.bound,
      setCashOutWin: action.bound,
      setIsBetsClosed: action.bound,
      setIsDoSpinStart: action.bound,
      setIsAllowSendBet: action.bound,
      setIsDoSpinResult: action.bound,
      updateLastResults: action.bound,
      setIsAllowCashOut: action.bound,
      setLastStepResult: action.bound,
      setIsStartAnimation: action.bound,
    });
    reaction(
      () => this.isDoSpinStart,
      (value) => {
        const { setIsAllowedChangeCurrency } = userInfoStore;
        setIsAllowedChangeCurrency(!value);
        if (freeBetStore.currentFreeBet && !freeBetStore.currentFreeBet.remainingCount && !value) {
          freeBetStore.setIsShowFreeBetPopup(true);
        }
      }
    );
  }

  setNextOdd(odd) {
    this.nextOdd = odd;
  }

  setLastStepResult(result) {
    this.lastStepResult = result;
  }

  setIsDoSpinResult(result) {
    this.isDoSpinResult = result;
  }

  setIsStartAnimation(bool) {
    this.isStartAnimation = bool;
  }

  setIsAllowSendBet(bool) {
    this.isAllowSendBet = bool;
  }

  setLastResults(results) {
    this.lastResults = results;
  }

  updateLastResults(result) {
    const updatedLastResult = [...this.lastResults, result];
    if (updatedLastResult.length > (isMobile() ? 2 : 4)) {
      updatedLastResult.splice(0, 1);
    }
    this.setLastResults(updatedLastResult);
  }

  setWinAmount(amount) {
    this.winAmount = amount;
  }

  setWinOdd(odd) {
    this.winOdd = odd;
  }

  setOdd(odd) {
    this.odd = odd;
  }

  setIsBetsClosed(bool) {
    this.isBetsClosed = bool;
  }

  setIsAllowCashOut(bool) {
    this.isAllowCashOut = bool;
  }

  setCashOutWin(amount) {
    this.cashOutWin = amount;
  }

  setIsDoSpinStart(bool) {
    this.isDoSpinStart = bool;
  }

  resetStore() {
    this.isBetsClosed = false;
    this.isDoSpinStart = false;
    this.isAllowCashOut = false;
    this.cashOutWin = null;
    this.winAmount = null;
    this.winOdd = null;
    this.isDoSpinResult = false;
    this.lastResults = [];
    this.isStartAnimation = false;
    this.lastStepResult = null;
    this.nextOdd = null;
  }
}

export const coinFlipBetsStore = new CoinFlipBetsStore();
